import React, { FC } from 'react';
import classNames from 'classnames';

import classes from './styles/index.module.scss';
import { AvatarProps } from './types';

export const Avatar: FC<React.PropsWithChildren<AvatarProps>> = ({
	photoUrl = '',
	initials = '',
	size = 'normal',
	className,
}) => {
	const hasPhoto = photoUrl !== null && photoUrl.trim() !== '';
	const avatarClasses = classNames(classes.avatar, className, {
		[classes.avatar_small]: size === 'small',
		[classes.avatar_medium]: size === 'medium',
		[classes.avatar_normal]: size === 'normal',
		[classes.avatar_large]: size === 'large',
		[classes.avatar_extraLarge]: size === 'extra-large',
		[classes.avatar_noImage]: !hasPhoto,
	});

	return (
		<div className={avatarClasses}>
			<div className={classes.imageSection}>
				{hasPhoto ? (
					<img
						className={classes.image}
						src={photoUrl!}
						alt={initials}
					/>
				) : (
					initials
				)}
			</div>
		</div>
	);
};
